import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/Button';
const apps = [{
  name: 'CorkShip',
  platform: 'Built for Shopify and Commerce7',
  description: 'eParcel shipping for wineries. Smart carton assignment, age verification, and manifest management.',
  link: 'https://corkship.io/'
}, {
  name: 'Personalization Engine',
  platform: 'Built for Shopify',
  description: 'Show the right content to the right customer. Page and cart personalization with one rules engine.',
  link: null
}, {
  name: 'Wine Bundles',
  platform: 'Built for Shopify',
  description: 'Case pricing that works how wineries sell. Automatic quantity discounts for 6, 12, and 24 bottle packs.',
  link: null
}, {
  name: 'Wine Allocation',
  platform: 'Built for Shopify',
  description: 'Manage limited releases with precision. Control who buys, how much, and when.',
  link: null
}, {
  name: 'Loyalty',
  platform: 'Built for Shopify',
  description: 'Reward your best customers. Points, tiers, and referrals designed for wine and DTC brands.',
  link: null
}];
const partnerApps = [{
  name: 'WinePik',
  description: 'Wine club subscription platform. Launching on Shopify.'
}, {
  name: 'Naiomi AI',
  description: 'Conversational analytics for your tech stack. Shopify-focused.'
}];
export function AppsDivision() {
  const [email, setEmail] = useState('');
  const [selectedApps, setSelectedApps] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleAppToggle = (appName: string) => {
    setSelectedApps(prev => prev.includes(appName) ? prev.filter(name => name !== appName) : [...prev, appName]);
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetch('https://cru-forms.cruio.workers.dev/api/app-waitlist', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email,
          apps: selectedApps
        })
      });
      if (response.ok) {
        setEmail('');
        setSelectedApps([]);
        alert("You're on the list! We'll notify you when we launch.");
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
    setIsSubmitting(false);
  };
  return <main className="flex-grow bg-[#F2F4F0]" data-id="element-113">
      {/* 1. HERO SECTION */}
      <section className="py-20 md:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-114">
        <h1 className="text-5xl md:text-6xl font-serif font-semibold text-text mb-6" data-id="element-115">
          Apps Division
        </h1>
        <p className="text-xl md:text-2xl text-muted font-sans max-w-3xl mx-auto" data-id="element-116">
          Purpose-built applications for wineries and DTC brands.
        </p>
      </section>

      {/* 2. OUR APPS SECTION */}
      <section className="py-16 md:py-24 bg-white" data-id="element-117">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-text mb-12" data-id="element-119">
            Our Apps
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-120">
            {apps.map((app, index) => <div key={index} className="bg-white p-8 rounded shadow-warm border border-border hover:border-primary transition-colors duration-200" data-id="element-121">
                <div className="flex items-baseline gap-2 mb-3" data-id="element-122">
                  <h3 className="text-xl font-serif font-semibold text-text" data-id="element-123">
                    {app.name}
                  </h3>
                  <span className="text-sm text-muted font-sans" data-id="element-124">
                    ({app.platform})
                  </span>
                </div>
                <p className="text-muted leading-relaxed mb-4" data-id="element-125">
                  {app.description}
                </p>
                {app.link ? <a href={app.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center font-semibold text-primary hover:opacity-80 transition-colors" data-id="element-126">
                    View app
                    <ArrowRight className="ml-2 w-4 h-4" data-id="element-127" />
                  </a> : <span className="inline-flex items-center font-semibold text-muted" data-id="element-128">
                    Launching Soon
                  </span>}
              </div>)}
          </div>
        </div>
      </section>

      {/* 3. PARTNER APPS SECTION */}
      <section className="py-16 md:py-24 bg-[#F2F4F0]" data-id="element-129">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-130">
          <div className="max-w-3xl mb-12" data-id="element-131">
            <h2 className="text-3xl md:text-4xl font-serif font-semibold text-text mb-6" data-id="element-132">
              Partner Apps
            </h2>
            <p className="text-lg text-muted leading-relaxed" data-id="element-133">
              We're the agency launch partner for two platforms expanding the
              wine commerce ecosystem and introducing AI conversational
              analytics.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-134">
            {partnerApps.map((app, index) => <div key={index} className="bg-white p-8 rounded shadow-warm border border-border" data-id="element-135">
                <div className="flex items-center gap-3 mb-3" data-id="element-136">
                  <h3 className="text-xl font-serif font-semibold text-text" data-id="element-137">
                    {app.name}
                  </h3>
                  <span className="inline-block px-2 py-1 rounded text-xs font-bold uppercase tracking-wider bg-primary/10 text-primary" data-id="element-138">
                    Partner
                  </span>
                </div>
                <p className="text-muted leading-relaxed" data-id="element-139">{app.description}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 4. STATUS / IN DEVELOPMENT SECTION */}
      <section className="py-16 md:py-24 bg-white" data-id="element-140">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
          <div className="max-w-2xl mx-auto text-center" data-id="element-142">
            <h2 className="text-3xl md:text-4xl font-serif font-semibold text-text mb-6" data-id="element-143">
              In Development
            </h2>
            <p className="text-lg text-muted leading-relaxed mb-10" data-id="element-144">
              Our apps are currently in development, with CorkShip awaiting
              Shopify App Store review. Sign up to get notified when they
              launch.
            </p>

            <form onSubmit={handleSubmit} className="max-w-md mx-auto" data-id="element-145">
              <div className="mb-6" data-id="element-146">
                <p className="text-sm font-semibold text-text mb-3" data-id="element-147">
                  Which apps are you interested in?
                </p>
                <div className="flex flex-wrap justify-center gap-3" data-id="element-148">
                  {apps.map(app => <label key={app.name} className={`inline-flex items-center px-4 py-2 rounded border cursor-pointer transition-all ${selectedApps.includes(app.name) ? 'bg-primary/10 border-primary text-primary' : 'bg-white border-border text-text hover:border-primary/50'}`} data-id="element-149">
                      <input type="checkbox" checked={selectedApps.includes(app.name)} onChange={() => handleAppToggle(app.name)} className="sr-only" data-id="element-150" />
                      <span className="text-sm font-medium" data-id="element-151">{app.name}</span>
                    </label>)}
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4" data-id="element-152">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email" required className="flex-grow px-4 py-3 rounded border border-border bg-white text-text placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent" data-id="element-153" />
                <Button type="submit" disabled={isSubmitting} data-id="element-154">
                  {isSubmitting ? 'Joining...' : 'Notify Me'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* 5. CTA SECTION */}
      <section className="py-24 px-4 sm:px-6 lg:px-8 text-center bg-[#F2F4F0]" data-id="element-155">
        <div className="max-w-3xl mx-auto space-y-8" data-id="element-156">
          <h2 className="text-4xl md:text-5xl font-serif font-semibold text-text" data-id="element-157">
            Need something custom?
          </h2>

          <p className="text-xl text-muted font-sans" data-id="element-158">
            Got an app idea or need a solution we haven't built yet? Let's talk.
          </p>

          <div className="pt-4" data-id="element-159">
            <Link to="/contact" data-id="element-160">
              <Button size="lg" data-id="element-161">Get in Touch</Button>
            </Link>
          </div>
        </div>
      </section>
    </main>;
}